import {
// DatePicker,
SelectMenu, SimpleModal, toast } from '@livable/saas-react-components';
import { Button,
// FormControlLabel,
MenuItem,
// Radio, RadioGroup,
Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import useStyles from './styles';
const AddCustomBilling = observer(() => {
  const classes = useStyles();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const billingTab = currentCompany.billingTab || {};
  const customTableUtilityId = billingTab.customTableUtilityId;
  const isOpen = billingTab.isCustomTableOpen;
  const setCustomTableUtilityId = billingTab.setCustomTableUtilityId;
  const _billingTab$customTab = billingTab.customTable,
    allocationCycleId = _billingTab$customTab.allocationCycleId,
    propertyId = _billingTab$customTab.propertyId,
    utilities = _billingTab$customTab.utilities;

  // const [type, setType] = React.useState('custom');
  // const handlePlanChange = e => setType(e.target.value);

  const postCustomBillingCycle = async data => {
    const resp = await store.allocations.postCustomBillingCycleAsync.run(data);
    return resp;
  };
  const closeModal = () => {
    billingTab.setCustomTableIsOpen(false);
    billingTab.setCustomTable({
      allocationCycleId: null,
      propertyId: null,
      utilities: []
    });
    setCustomTableUtilityId(null);
  };
  const handleAddCustomBilling = async () => {
    const data = {
      allocationCycleId,
      propertyId,
      utilityId: customTableUtilityId
    };
    await postCustomBillingCycle(data).then(resp => {
      var _store$homeDashboardS;
      const billingCycleId = resp === null || resp === void 0 ? void 0 : resp.response.billingCycleId;
      billingTab.addToPreviewQueue({
        billingCycleId,
        id: billingCycleId + propertyId,
        portfolioId: ((_store$homeDashboardS = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id) || '',
        propertyId
      });
    }).then(() => currentCompany.billingTab.updateBillingSummaryTimestamp()).then(() => toast('success', {
      body: ['Custom billing added successfully']
    })).finally(() => closeModal());
  };
  const handleClose = () => closeModal();
  const handleUtilityChange = event => setCustomTableUtilityId(event.target.value);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    isOpen: isOpen,
    noFooter: true,
    noPadding: true,
    title: "Add custom billing"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.addCustomBilling
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.addCustomBillingSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.addCustomBillingSetting
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.addCustomBillingSettingTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Select utility")), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Utility",
    labelId: "utility-selector-label",
    onChange: handleUtilityChange,
    value: customTableUtilityId
  }, utilities === null || utilities === void 0 ? void 0 : utilities.map(u => /*#__PURE__*/React.createElement(MenuItem, {
    key: u.utilityId,
    value: u.utilityId
  }, u.utilityName)))))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    variant: "text",
    'custom-attribute': '598-new-billing-module'
  }, t('Close'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !customTableUtilityId || store.allocations.postCustomBillingCycleAsync.inProgress,
    onClick: handleAddCustomBilling,
    type: "button",
    variant: "contained",
    'custom-attribute': '599-new-billing-module'
  }, t('Add custom billing'))))))));
});
export default AddCustomBilling;